import { BotaoDeContato } from '@inscricao/components/Contato';
import { curso, fatosDaAbertura } from '@curso/content/curso';
import { ComPontos } from '@shared/components/moldes';

/**
 * A abertura, acima da moldura de abas.
 *
 * Compacta de propósito. Ela responde o que é, quando é e para quem, e sai da
 * frente: a moldura precisa aparecer sem rolagem, senão a página volta a ler
 * como texto corrido.
 *
 * A hierarquia é deliberada. O nome do curso fica no rótulo, porque identifica
 * mas não convence. O título é a frase que carrega o posicionamento, porque é
 * ela que faz a pessoa continuar lendo.
 */
export function Abertura() {
  return (
    <section id="abertura" className="abertura border-b border-linha bg-papel">
      <div className="mx-auto w-full max-w-5xl px-6 pt-12 pb-10 sm:px-10 sm:pt-16 sm:pb-12">
        {/* Balanceado: sem isso, no celular "HCRM" cai sozinho na segunda linha. */}
        <p className="rotulo surgir text-balance">
          <ComPontos texto={`${curso.nome} · ${curso.formato}`} />
        </p>

        <h1 className="display-hero surgir mt-5 max-w-3xl" style={{ animationDelay: '80ms' }}>
          {/*
            Quebra fixa depois de "humano.", pedido de 20/10. Sem ela o
            navegador quebrava onde coubesse, e a segunda frase comecava na
            primeira linha: "O erro e humano. A / confiabilidade...". As duas
            frases sao duas ideias, e cada uma tem a propria linha.
          */}
          {curso.chamada.split('. ').map((frase, indice, todas) => (
            <span key={frase} className="block">
              {indice < todas.length - 1 ? `${frase}.` : frase}
            </span>
          ))}
        </h1>

        <div
          className="surgir mt-6 flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between"
          style={{ animationDelay: '160ms' }}
        >
          <div className="max-w-md">
            <p className="prosa">{curso.promessa}</p>
            <ul className="prosa mt-2 space-y-0.5">
              {curso.competenciasDaPromessa.map((competencia) => (
                <li key={competencia} className="flex gap-3">
                  <span aria-hidden className="text-destaque">
                    ·
                  </span>
                  {competencia}
                </li>
              ))}
            </ul>
            {/*
              Em tinta-suave, nao em tinta-fraca. Sobre a foto, o tom fraco
              nao passa em AA nem com o veu reforcado: ele e claro demais para
              fundo que nao e liso. A diferenca entre os dois paragrafos vem
              do tamanho, 18 contra 15, que ja basta.
            */}
            <p className="mt-4 text-apoio leading-relaxed text-pretty text-tinta-suave">
              {curso.publico}
            </p>
          </div>

          {/*
            O botao sozinho, sem caixa.

            Ate 19/10 havia aqui uma base opaca com fio em cima, dimensionada
            para um formulario de quatro campos. O formulario virou dialogo, e
            a caixa ficou com 260 por 129 pixels para abrigar um botao de 161
            por 44: mais da metade vazia, lendo como cartao sem conteudo.
          */}
          <div className="shrink-0">
            {/*
              So o botao, sem linha de apoio.

              A frase "Escrevemos uma vez" ficava aqui, e aqui e exatamente
              onde o veu abre para a foto aparecer: medida sobre a parte
              escura da imagem, ela caia para 1.9 de contraste. E o dialogo ja
              diz a mesma coisa na primeira linha, agora com o motivo de pedir
              o WhatsApp junto.

              O botao nao corre o mesmo risco: ele tem fundo proprio.
            */}
            <BotaoDeContato origem="abertura" />
          </div>
        </div>

        <p
          className="horizonte surgir mt-11 text-apoio text-tinta-suave"
          style={{ animationDelay: '240ms' }}
        >
          {/* Montada em curso.ts: a frase cola preposicao, e gramatica mora com as palavras. */}
          <ComPontos texto={fatosDaAbertura} />
        </p>
      </div>
    </section>
  );
}
